"use client";

import Link from "next/link";
import { useEffect, useRef, useState } from "react";
import { cn } from "@/utils";
import { Button } from "./button";
import { HamburgerIcon, XIcon } from "./icons/icons";

export const Menu = () => {
	const [isOpen, setIsOpen] = useState(false);

	const scrollPositionRef = useRef(0);

	useEffect(() => {
		if (isOpen) {
			scrollPositionRef.current = window.pageYOffset;
			document.body.style.top = -scrollPositionRef.current + "px";
			document.body.classList.add("show-overlay");
		} else {
			document.body.style.top = "";
			document.body.classList.remove("show-overlay");
			window.scrollTo(0, scrollPositionRef.current);
		}
	}, [isOpen]);

	return (
		<>
			<button
				type="button"
				className="appearance-none order-1 md:hidden"
				onClick={() => setIsOpen((isOpen) => !isOpen)}
			>
				<HamburgerIcon />
			</button>

			<Overlay isOpen={isOpen} onClose={() => setIsOpen(false)} />

			<ul
				className={cn(
					"hidden",
					"md:flex md:flex-row md:items-center md:gap-x-10 md:mx-auto md:text-pregular md:leading-pregular md:tracking-pregular md:text-neutral-700",
				)}
			>
				<LinksInner />
			</ul>
		</>
	);
};

const LinksInner = () => {
	return (
		<>
			<li>
				<Link href="/#features">Features</Link>
			</li>
			<li>
				<Link href="/#technology">Technology</Link>
			</li>
			<li>
				<Link href="/pricing">Pricing</Link>
			</li>
			{/* @todo */}
			{/* <li>
				<Link href="/blog">Blog</Link>
			</li> */}
		</>
	);
};

const Overlay = ({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) => {
	return (
		<div
			id="overlay"
			className={cn(
				"fixed left-0 top-0 right-0 -z-50 opacity-0 bg-white transition-[z-index,opacity] duration-300 ease-in-out pointer-events-none",
				isOpen && "opacity-100 z-50 overscroll-contain overflow-y-scroll pointer-events-auto",
				"md:hidden",
			)}
		>
			<button type="button" onClick={onClose} className="absolute top-2 right-4 z-50">
				<XIcon />
			</button>
			<div className="flex flex-col items-center justify-center h-[100dvh] pb-10">
				<ul className="flex flex-col items-center justify-center flex-1 gap-y-8 text-pregular leading-pregular tracking-pregular text-neutral-700">
					<LinksInner />
				</ul>
				<div className="flex flex-row gap-4">
					<Button asChild>
						<Link href="https://yns.store/admin" target="_blank">
							Login
						</Link>
					</Button>
					<Button asChild variant="light">
						<Link href="https://yns.store/admin" target="_blank">
							Sign up
						</Link>
					</Button>
				</div>
			</div>
		</div>
	);
};
